var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6912,
    stroke: "#000",
    d: "M27.474 14.161c0 7.354-5.961 13.315-13.315 13.315s-13.315-5.961-13.315-13.315c0-7.354 5.961-13.315 13.315-13.315 0.001 0 0.001 0 0.002 0h-0c7.354 0 13.315 5.961 13.315 13.315v0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6912,
    stroke: "#000",
    d: "M30.804 30.804l-7.24-7.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2b3b029a9a014706e7430c02a44de4e5.svg";
export { ForwardRef as ReactComponent };